import { useOutletContext } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { Divider } from "primereact/divider";
import TabHeader from "../../common/TabHeader";
import Loading from "../../common/Loading";
import NoContent from "../../common/NoContent";
import { useAppContext } from "../../../providers/ProviderAppContainer";
import { updateCurrentUser } from "../../../redux/sliceUser";
import { getReadableDate } from "../../../utils";
import { TEXT_NORMAL, TEXT_SMALL } from "../../../style";

export default function UserNotifications() {
    const { userId } = useOutletContext();
    const dispatch = useDispatch();
    const loggedInUserId = useSelector((state) => state.stateUser?.id);
    const { requestAPI } = useAppContext();

    const [notifications, setNotifications] = useState();
    const [loading, setLoading] = useState();
    const [error, setError] = useState();

    useEffect(() => {
        requestAPI({
            requestPath: `users/${userId}/notifications`,
            requestMethod: "GET",
            setLoading,
            onRequestFailure: setError,
            onResponseReceieved: (data, responseCode) => {
                if (data && responseCode === 200) {
                    setNotifications(data);
                    if (Number(userId) === Number(loggedInUserId)) {
                        dispatch(updateCurrentUser({ unseen_notification_count: 0 }));
                    }
                } else {
                    setError("Couldn't load Notifications");
                }
            },
        });
    }, [dispatch, loggedInUserId, requestAPI, userId]);

    return (
        <div className="flex flex-column h-full min-h-0">
            <TabHeader
                className="px-3 pt-3"
                title="Notifications"
                highlights={[`Total - ${notifications?.length ?? 0} Notifications`]}
            />
            <Divider />
            <div className="flex-1 min-h-0 px-3 pb-2 overflow-y-scroll flex flex-column gap-2">
                {loading && <Loading />}
                {!loading && error && <NoContent message={error} />}
                {!loading && !error && !notifications?.length && <NoContent message="No notifications yet" />}
                {!loading &&
                    !error &&
                    notifications?.map((notification) => {
                        const unseen = !Number(notification.seen);
                        return (
                            <div
                                key={notification.id}
                                className={`border-1 border-round-md p-3 ${unseen ? "border-primary font-semibold" : "border-gray-300 opacity-80"}`}
                                style={{ backgroundColor: notification.type_color || "#F9FAFB" }}
                            >
                                <div className="flex align-items-center justify-content-between gap-2 mb-1">
                                    <span className={`${TEXT_NORMAL}`}>{notification.title}</span>
                                    <span className={`${TEXT_SMALL} white-space-nowrap`}>
                                        {notification.type_title}
                                        {unseen ? " · New" : ""}
                                    </span>
                                </div>
                                {notification.description && (
                                    <p className={`${TEXT_SMALL} m-0 mb-2 white-space-pre-wrap`}>{notification.description}</p>
                                )}
                                <div className={`${TEXT_SMALL} text-color-secondary mb-1`}>
                                    {getReadableDate({ date: notification.created_on })}
                                </div>
                                {!!notification.attachments?.length && (
                                    <div className="flex flex-wrap gap-2 mt-1">
                                        {notification.attachments.map((item) => (
                                            <a
                                                key={item.id}
                                                href={item.attachment}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="text-primary"
                                                title="Open attachment"
                                            >
                                                <i className="pi pi-link text-xl" />
                                            </a>
                                        ))}
                                    </div>
                                )}
                            </div>
                        );
                    })}
            </div>
        </div>
    );
}
